export default __webpack_public_path__ + "static/media/kfh.4aaa5143.png";